import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSubscriptionForUser } from "../../../action_managers/subscriptions";
import { fetchPublicShowForSubscriber } from "../../../action_managers/public_show";
import { AlbumDisplay } from "../../lib/album-art";
import get from "lodash/get";
import "./sponsor_show_list.scss";
import { Row, Col, Grid, Button } from "react-bootstrap";
import Divider from "../../lib/divider";
import { If } from "react-extras";
import Spinner from "../../lib/spinner";

const popularShows = [
  {
    title: "CzabeCast Premium",
    uuid: "2a60ac83-f8ca-48fd-92dd-6fc24ba3b094",
  },
  {
    title: "The Baller Lifestyle Podcast",
    uuid: "0cc69c2b-8c5a-4a70-b47c-9e5b1ce0e387",
  },
  {
    title: "Parenting Beyond Discipline",
    uuid: "a434a9c9-54fe-485b-b781-0e59eb5a4fbc",
  },
];

class SponsorShowList extends Component {
  state = {
    fetchingShows: false,
  };

  componentDidMount() {
    this.setState({ fetchingShows: true });
    Promise.all(
      popularShows.map(popularShow => this.props.fetchPublicShowForSubscriber(popularShow.uuid))
    ).finally(() => this.setState({ fetchingShows: false }));

    this.props.fetchSubscriptionForUser(this.props.user.uuid).then(resp => {
      if (resp.status === 200) {
        Object.keys(this.props.subscriptions)
          .filter(
            subscriptionUUID =>
              this.props.subscriptions[subscriptionUUID] &&
              !this.props.publicShows[this.props.subscriptions[subscriptionUUID].showUUID]
          )
          .map(subscriptionID => this.props.subscriptions[subscriptionID].showUUID)
          .forEach(showUUID => {
            this.props.fetchPublicShowForSubscriber(showUUID);
          });
      }
    });
  }

  getActiveSubscriptionIDs = () => {
    return this.getSubscriptionIDs().filter(
      subID => this.props.subscriptions[subID].state === "active"
    );
  };

  getInactiveSubscriptionIDs = () => {
    return this.getSubscriptionIDs().filter(
      subID => this.props.subscriptions[subID].state !== "active"
    );
  };

  getSubscriptionIDs = () => {
    return Object.keys(this.props.subscriptions).filter(
      subscriptionID =>
        this.props.subscriptions[subscriptionID].userUUID === this.props.user.uuid &&
        get(this.props.publicShows, [this.props.subscriptions[subscriptionID].showUUID])
    );
  };

  renderAlbumArts = (shows, withResubscribe) => {
    if (!get(shows, "length")) {
      return <div>You're not sponsoring any shows yet.</div>;
    }
    return (
      <Row>
        {shows.map(show => {
          return (
            <Col xs={6} sm={4} lg={3} key={show.uuid}>
              <AlbumDisplay
                src={show.imageURL}
                title={show.title}
                toURL={`/shows/${show.uuid}/sponsor`}
              />
              <If condition={withResubscribe === true}>
                <Button
                  className={"btn btn-primary width-100 m-ts"}
                  onClick={this.gotoURL(`/shows/${show.uuid}/resubscribe`)}>
                  Resubscribe
                </Button>
              </If>
            </Col>
          );
        })}
      </Row>
    );
  };

  gotoURL = url => {
    return () => {
      this.props.history.push(url);
      window.scrollTo(0, 0);
    };
  };

  render() {
    const activeSubIDs = this.getActiveSubscriptionIDs() || [];
    const activeShows = activeSubIDs.map(
      uuid => this.props.publicShows[this.props.subscriptions[uuid].showUUID]
    );
    const inactiveSubIDs = this.getInactiveSubscriptionIDs() || [];
    const inactiveShows = inactiveSubIDs.map(
      uuid => this.props.publicShows[this.props.subscriptions[uuid].showUUID]
    );
    const isLoading = this.props.isLoading || this.state.fetchingShows > 0;

    // Don't render a popular show if already subscribed.
    const allShowUUIDs = inactiveShows.concat(activeShows).map(show => show.uuid);
    const popularShowsToRender = popularShows
      .map(show => this.props.publicShows[show.uuid])
      .filter(show => show)
      .filter(show => !allShowUUIDs.includes(show.uuid));

    if (isLoading) {
      return (
        <div className={"sponsor-show-list p-vxxl"}>
          <Spinner isLoading={true} />
        </div>
      );
    }
    return (
      <div className={"sponsor-show-list"}>
        <Grid fluid>
          <Row>
            <Col md={8} mdOffset={2}>
              <h2>Podcasts you're sponsoring</h2>
              <Divider smallMargin />
              {this.renderAlbumArts(activeShows, false)}
            </Col>
          </Row>
          <If condition={inactiveSubIDs.length > 0}>
            <Row>
              <Col md={8} mdOffset={2}>
                <h2 className={"m-txl"}>Podcasts you're no longer sponsoring</h2>
                <Divider smallMargin />
                {this.renderAlbumArts(inactiveShows, true)}
              </Col>
            </Row>
          </If>
          <Row>
            <Col md={8} mdOffset={2}>
              <h2 className={"m-txl"}>Popular podcasts to sponsor</h2>
              <Divider smallMargin />
              {this.renderAlbumArts(popularShowsToRender, false)}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    subscriptions: state.subscriptions.subscriptions,
    publicShows: state.publicShows,
    isLoading: state.subscriptions.isLoading || state.publicShows.isLoading,
  };
}

export default connect(mapStateToProps, {
  fetchPublicShowForSubscriber,
  fetchSubscriptionForUser,
})(SponsorShowList);
